import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { AssetDetailsModel, AssetStatusCategories } from 'src/app/asset/models/asset.model';
import { AssetService } from 'src/app/core/services/http/agency-mgmt/asset.service';
import { EventService } from 'src/app/core/services/http/event.service';
import { AssetMaintenanceCycleType, AssetMaintenanceCycleTypeOptions } from 'src/app/property/constants/asset-maintenance-cycle.enum';
import { Events } from 'src/app/shared/constants/events.constant';

@Component({
  selector: 'app-asset-list-view',
  templateUrl: './asset-list-view.component.html',
  styleUrls: ['./asset-list-view.component.scss']
})
export class AssetListViewComponent implements OnInit,OnDestroy {

  constructor(private assetService: AssetService,
    private eventService: EventService
  ) { }
  @Input() selectedPropertyId: string;
  @Input() assetStatus: any;
  pageNumber: number = 0;
  pageSize: number = 5;
  totalPage: number = 0;
  isAssetView : boolean = false;
  selectedAssetId: string;
  selectedAssetCategory: string;
  public isAssetLoading: boolean = false;
  public assetDetailList: AssetDetailsModel[] = []
  private sub: Subscription[] = [];
  private actionEventList :Events[]=[Events.ApproveAssetEvent,Events.DeleteAssetEvent,
                                     Events.SentToTenantAssetEvent,Events.EditAssetEvent]
  ngOnInit(): void {
    this.getSelectedAssetCategoryByPropery();
    this.listenToAssetActionEvent();
    this.selectedAssetCategory = AssetStatusCategories[this.assetStatus];
  }
  ngOnDestroy(): void {
    this.sub.forEach((sub) => sub.unsubscribe());
  }
  getSelectedAssetCategoryByPropery() {
    this.assetDetailList = [];
    this.isAssetLoading = true;
    this.assetService.getSelectedAssetCategoryByPropery(this.assetStatus, this.pageNumber + 1, this.pageSize, this.selectedPropertyId)
      .subscribe({
        next: (response) => {
          if (response != null && response.length > 0) {
            this.totalPage = response[0]?.totalRowCount;
            this.assetDetailList = response;
          }
          this.isAssetLoading = false;
        },
        error: () => {
          this.isAssetLoading = false;
        }
      })
  }
  
  listenToAssetActionEvent(){
   if (this.sub[0])this.sub[0].unsubscribe();
   this.sub[0] = this.eventService.events.subscribe((event) => {
      if (this.actionEventList.some((e)=>e == event)) {
       this.getSelectedAssetCategoryByPropery();
      }
    });
  }

  getPaginatedResult(event: any) {
    this.pageNumber = event.pageIndex;
    this.getSelectedAssetCategoryByPropery();
  }


  view(assetId : string){
    this.isAssetView = true;
    this.selectedAssetId = assetId;
  }

  closeAssetDetails(){
    this.isAssetView = false;
    this.selectedAssetId = null;
  }
  selectAsset(assetId){
    var assetDetailListTemp = this.assetDetailList;
    this.assetDetailList =[];
    assetDetailListTemp.map(asset =>{
      if(asset.id == assetId && !asset.isSelected){
        asset.isSelected = true;
      }else{
        asset.isSelected = false;
      }
    });
    this.assetDetailList = assetDetailListTemp;
  }

  maintenanceCycleLabel(maintenanceCycle: AssetMaintenanceCycleType) {
    return typeof maintenanceCycle === 'number' && !isNaN(maintenanceCycle)
        ? AssetMaintenanceCycleTypeOptions.find(elem => elem.key == maintenanceCycle)?.value || ''
        : '';
  }

}
